import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from 'auth';
import { ToastrService } from 'ngx-toastr';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const toastr = inject(ToastrService);

  const isLoggedIn = authService.isLoggedIn();
  const roles = authService.getUserRole();

  if (isLoggedIn && roles.includes('Staff')) {
    return true;
  }

  toastr.error('You are not authorized to access this page');
  router.navigate(['/login']);
  return false;
};
